/**
noop()
Does nothing, returns undefined.
**/

export default function noop() {}
